import request from "@/utils/request";

/** 根据课程码和会员sub查询课程极其关联课列表 */
export async function getCourseWithLessons(courseCode, sub) {
    return request({
        url: `/course/${courseCode}/member/${sub}`,
        method: 'get'
    })
}

/** 根据课程码和所关联课主键查询句列表及其词列表 */
export async function getSentencesWithWords(courseCode, lessonId) {
    return request({
        url: `/course/${courseCode}/lesson/${lessonId}`,
        method: 'get'
    })
}

/** 根据课程码和所关联课主键查询语法列表 */
export async function getGrammars(courseCode, lessonId) {
    return request({
        url: `/course/${courseCode}/grammar/${lessonId}`,
        method: 'get'
    })
}

/** 增加或取消会员课程关联表的书签信息 */
export async function putBookmark(courseCode, bookmark) {
    return request({
        url: `/course/${courseCode}/bookmark`,
        method: 'put',
        data: bookmark
    })
}

